export const SECTIONS = {
  rooms_cards: 'roomsCards',
  transactions: 'transactions',
  listings_statuses: 'listingStatuses',
  become_trusted_user: 'becomeTrustedUser',
  list_a_room: 'listARoom',
  lister_score: 'listerScore',
  lister_metrics: 'listerMetrics',
};
